import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=4555dbf5&scoped=true&"
import script from "./OfferList.vue?vue&type=script&lang=ts&"
export * from "./OfferList.vue?vue&type=script&lang=ts&"
import style0 from "./OfferList.vue?vue&type=style&index=0&id=4555dbf5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555dbf5",
  null
  
)

export default component.exports